import { highlightText } from "@/lib/textRendering";

window.highlightText = highlightText;
